exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*#header-container {\n  width: auto;\n  margin-bottom: 10px;\n}\n\n#header-container table tr td {\n  white-space: nowrap;\n}*/\n#logo-small[data-v-7c46bdca] {\n  max-width: 3cm;\n  width: auto;\n  height: auto;\n}\n.spacer[data-v-7c46bdca]{\n  width: 20%;\n}\n.small-text[data-v-7c46bdca] {\n  font-size: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7c46bdca","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ReportHeader.vue
// module id = bcrL
// module chunks = 97